import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AssetsService } from "../assets.service";
import { MessagesService } from "../../messages.service";
import { History } from "./history.model";

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {

  serialNumber : string;
  page : number;
  size : number; 
  hasMore : boolean;
  loadingResults : boolean;
  movements : Array<History> = [];
    
  constructor(private assetsService: AssetsService, private messagesService: MessagesService, private route: ActivatedRoute) { }

    
  ngOnInit() {
    this.serialNumber = this.route.snapshot.params["serialnumber"];
    this.page = 0;
    this.size = 20;
    this.movements = [];
    this.hasMore = false;
    this.loadingResults = false;
    this.searchHistory();
  }

  searchHistory() {
    this.loadingResults = true;
    this.assetsService.getHistory(this.serialNumber, this.page, this.size).subscribe(
            data => {
                this.loadingResults = false;
                this.hasMore = data && data.length > 0;
                this.page = this.page + 1;
                this.movements = data;
            },
            error => { 
                this.loadingResults = false;
                this.checkError(error, 'Ha ocurrido un error al cargar las movimiento históricos');
                
            }
        );
  }
    
  private checkError(error: any, defaultMessage: string) {
    this.messagesService.checkError(error, defaultMessage);
  }
    
  public getMovIcon(movType:any) {
    if (movType == 'D') {
        return 'fa-truck';
        
    }
    if (movType == 'M') {
        return 'fa-arrows'
        
    }
    if (movType == 'C') {
        return 'fa-barcode';
        
    }
    return '';
  }
    
  public getMovColor(movType:any) {
    return 'mov-'+ movType; 
  }

    public getStatusClass(code: string) {
    if (code == "E") {
        return "label label-warning";
    }
    if (code == "U") {
        return "label label-info";
    }
    if (code == "F") {
        return "label label-success";
    }
    return "label label-success";
  }
    
}
